function Join() {
  return <div></div>;
}

export default Join;
